// Central site configuration for Szymkas Agency.
// Editing this single file updates content across the entire website.

export const site = {
    companyName: "Szymkas Agency",
    ownerName: "Kacper Szymczyk",
    ownerRole: "Założyciel Szymkas Agency",
    phoneDisplay: "733 934 001",
    phoneLink: "+48733934001",
    email: "szymkas.agency@gmail.com",
    logoUrl:
        "https://customer-assets.emergentagent.com/job_ebaaf968-ef77-42bb-9716-bd3bcffa2e5e/artifacts/j96ucaai_SzymkasAgencyLogo.png",
    ownerPhoto:
        "https://customer-assets.emergentagent.com/job_marki-rosna/artifacts/zjnryc6q_Gemini_Generated_Image_8s8ewd8s8ewd8s8e.png",
    social: {
        instagram: "https://www.instagram.com/szymkasagency?igsh=MXdqbGczamp4NXg2cg%3D%3D&utm_source=qr",
        facebook: "https://www.facebook.com/share/197E7ecUKY/?mibextid=wwXIfr",
        linkedin: "https://www.linkedin.com/in/kacper-szymczyk-0562ab417?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
    },
    domain: "https://szymkasagency.pl",
    nav: [
        { label: "Strona główna", href: "/" },
        { label: "Usługi", href: "/uslugi" },
        { label: "Pakiety", href: "/pakiety" },
        { label: "Realizacje", href: "/realizacje" },
        { label: "Proces", href: "/proces" },
        { label: "O nas", href: "/o-nas" },
        { label: "Wiedza", href: "/blog" },
        { label: "Kontakt", href: "/kontakt" },
    ],
};

export const services = [
    {
        slug: "strony-internetowe",
        title: "Strony internetowe",
        short:
            "Projektujemy nowoczesne, responsywne strony, które profesjonalnie prezentują ofertę i prowadzą odbiorców do kontaktu.",
        icon: "Globe",
        problem:
            "Stara, wolna lub nieczytelna strona obniża zaufanie klientów i odbiera firmie szansę na pozyskanie wartościowych zapytań.",
        scope: [
            "Analiza branży, konkurencji i odbiorców",
            "Struktura informacji i mapa treści",
            "Projekt graficzny i prototyp UX/UI",
            "Strona responsywna (desktop, tablet, telefon)",
            "Teksty sprzedażowe i nagłówki",
            "Podstawowe SEO i meta opisy",
            "Konfiguracja domeny, hostingu i certyfikatu SSL",
        ],
        benefits: [
            "Profesjonalny pierwszy wrażenie i większe zaufanie odbiorców",
            "Szybkie, czytelne wezwania do działania",
            "Lepsza widoczność w wyszukiwarkach dzięki podstawom SEO",
            "Łatwa edycja treści po wdrożeniu",
        ],
    },
    {
        slug: "aplikacje",
        title: "Aplikacje",
        short:
            "Tworzymy aplikacje internetowe i mobilne dopasowane do procesów, potrzeb i celów firmy.",
        icon: "AppWindow",
        problem:
            "Powtarzalne procesy w arkuszach, e-mailach i komunikatorach pochłaniają czas i utrudniają skalowanie firmy.",
        scope: [
            "Analiza procesów i potrzeb biznesowych",
            "Specyfikacja funkcji i scenariuszy użytkownika",
            "Projekt UX/UI panelu i widoków",
            "Aplikacja internetowa (web) lub mobilna",
            "Integracje z narzędziami firmy",
            "Wdrożenie, dokumentacja i szkolenie",
        ],
        benefits: [
            "Mniej powtarzalnej pracy ręcznej",
            "Jeden spójny system zamiast wielu narzędzi",
            "Łatwiejsza obsługa klientów i zespołu",
            "Skalowalność wraz z rozwojem firmy",
        ],
    },
    {
        slug: "branding",
        title: "Branding",
        short:
            "Tworzymy logo, kolorystykę, typografię oraz materiały budujące spójny i rozpoznawalny wizerunek.",
        icon: "Palette",
        problem:
            "Niespójna identyfikacja wizualna sprawia, że marka wygląda przypadkowo i traci wiarygodność w oczach klientów.",
        scope: [
            "Audyt marki i pozycjonowanie",
            "Projekt logo i sygnetu",
            "Paleta kolorów i typografia",
            "Księga identyfikacji wizualnej",
            "Wizytówki, papier firmowy, szablony dokumentów",
            "Materiały do social mediów i prezentacji",
        ],
        benefits: [
            "Spójny i rozpoznawalny wizerunek",
            "Wyższa wiarygodność oferty",
            "Gotowe materiały do natychmiastowego użycia",
            "Solidny fundament dla przyszłych działań marketingowych",
        ],
    },
    {
        slug: "social-media",
        title: "Social media",
        short:
            "Opracowujemy strategię, grafiki i treści, dzięki którym marka komunikuje się regularnie i profesjonalnie.",
        icon: "MessageSquare",
        problem:
            "Brak czasu i pomysłów sprawia, że profile firmy stoją w miejscu, a potencjalni klienci wybierają konkurencję.",
        scope: [
            "Strategia komunikacji i ton marki",
            "Konfiguracja profili (Facebook, Instagram, LinkedIn)",
            "Szablony postów i grafik",
            "Plan publikacji i kalendarz treści",
            "Copywriting i hashtagi",
            "Comiesięczne raporty i optymalizacja",
        ],
        benefits: [
            "Regularna obecność bez chaosu i improwizacji",
            "Profesjonalna komunikacja zgodna z marką",
            "Większe zaangażowanie odbiorców",
            "Stabilny dopływ kontaktów z social mediów",
        ],
    },
    {
        slug: "marketing",
        title: "Marketing internetowy",
        short:
            "Pomagamy zwiększać widoczność, docierać do odpowiednich odbiorców i generować wartościowe zapytania.",
        icon: "Megaphone",
        problem:
            "Strona istnieje, ale nie generuje zapytań – brakuje świadomego planu działań i mierzenia efektów.",
        scope: [
            "Audyt obecnej obecności w internecie",
            "Strategia kanałów (SEO, Google Ads, Meta Ads)",
            "Konfiguracja analityki i konwersji",
            "Kampanie reklamowe i optymalizacja",
            "Tworzenie landing page'y kampanijnych",
            "Raporty i rekomendacje miesięczne",
        ],
        benefits: [
            "Skupienie budżetu na działaniach, które przynoszą wyniki",
            "Mierzalne efekty i jasne rekomendacje",
            "Większa liczba wartościowych zapytań",
            "Świadome decyzje oparte na danych",
        ],
    },
    {
        slug: "automatyzacje-ai",
        title: "Automatyzacje i AI",
        short:
            "Wykorzystujemy nowoczesne narzędzia do analizy, tworzenia, automatyzacji i optymalizacji działań.",
        icon: "Bot",
        problem:
            "Powtarzalne zadania, ręczne odpowiedzi i analizy zabierają godziny tygodniowo i ograniczają rozwój firmy.",
        scope: [
            "Audyt procesów do automatyzacji",
            "Boty i automatyczne odpowiedzi (FB, IG, e-mail)",
            "Generowanie treści wspierane przez AI",
            "Automatyczne raporty i analizy",
            "Integracje (CRM, arkusze, Notion, Slack)",
            "Szkolenie zespołu z narzędzi AI",
        ],
        benefits: [
            "Mniej czasu na powtarzalne zadania",
            "Szybsza obsługa zapytań klientów",
            "Konsekwentna komunikacja 24/7",
            "Konkurencyjna przewaga w branży",
        ],
    },
];

export const socialMediaPlan = {
    slug: "prowadzenie-social",
    name: "Prowadzenie profilu w social mediach",
    priceFrom: "799 zł / miesiąc",
    description:
        "Regularne i profesjonalne prowadzenie profilu firmowego, dopasowane do charakteru marki, branży oraz odbiorców.",
    cta: "Zapytaj o prowadzenie profilu",
    note: "Kampanie płatne i budżet reklamowy są wyceniane osobno.",
    features: [
        "Przygotowanie planu komunikacji",
        "Tworzenie treści postów",
        "Przygotowanie profesjonalnych grafik",
        "Planowanie i publikowanie materiałów",
        "Dbanie o spójny wizerunek profilu",
        "Dobór tematów dopasowanych do odbiorców",
        "Podstawowa analiza działań i rekomendacje rozwoju",
    ],
    contactValue: "Prowadzenie social mediów – 799 zł / miesiąc",
};

export const packages = [
    {
        slug: "start",
        name: "Start",
        priceFrom: "od 2 190 zł",
        description:
            "Dla nowych i lokalnych firm, które potrzebują profesjonalnego początku w internecie.",
        highlighted: false,
        cta: "Wybieram Start",
        features: [
            "Analiza branży i konkurencji",
            "Podstawowa identyfikacja wizualna",
            "Proste logo lub odświeżenie obecnego",
            "Strona internetowa typu landing page (do 6 sekcji, w pełni responsywna)",
            "Wersja mobilna",
            "Formularz kontaktowy",
            "Podstawowe teksty",
            "Konfiguracja jednego profilu social media",
            "5 szablonów postów",
            "2 rundy poprawek",
            "14 dni wsparcia po publikacji",
        ],
    },
    {
        slug: "rozwoj",
        name: "Rozwój",
        priceFrom: "od 3 490 zł",
        description:
            "Dla firm, które chcą profesjonalnie prezentować ofertę i przygotować markę do zdobywania klientów online.",
        highlighted: true,
        badge: "Najczęściej wybierany",
        cta: "Wybieram Rozwój",
        features: [
            "Rozszerzony audyt",
            "Strategia marki",
            "Projekt logo",
            "Paleta kolorów i typografia",
            "Skrócona księga identyfikacji",
            "Strona do 5 podstron",
            "Teksty sprzedażowe",
            "Podstawowe SEO",
            "Konfiguracja analityki",
            "Facebook i Instagram",
            "10 szablonów postów",
            "30-dniowy plan publikacji",
            "2 rundy poprawek",
            "30 dni wsparcia",
        ],
    },
    {
        slug: "skala",
        name: "Skala",
        priceFrom: "od 6 490 zł",
        description:
            "Dla rozwijających się firm, które potrzebują kompleksowego systemu wizerunku i marketingu.",
        highlighted: false,
        cta: "Porozmawiajmy o projekcie",
        features: [
            "Pełny audyt i strategia",
            "Profesjonalny branding",
            "Księga marki",
            "Rozbudowana strona do 8 podstron",
            "Indywidualny UX/UI",
            "Teksty sprzedażowe",
            "Analityka i mierzenie konwersji",
            "Profile Facebook, Instagram i LinkedIn",
            "20 szablonów social media",
            "Kalendarz publikacji",
            "Scenariusze materiałów wideo",
            "Przygotowanie kampanii reklamowej",
            "Automatyczna odpowiedź na zapytania",
            "3 rundy poprawek",
            "60 dni wsparcia",
        ],
    },
];

export const portfolio = [
    {
        slug: "kawiarnia-lokalna",
        title: "Strona dla lokalnej kawiarni",
        category: "Strona WWW + Branding",
        problem:
            "Lokalna kawiarnia bez własnej strony, z niespójną komunikacją w social mediach i brakiem systemu rezerwacji stolika.",
        solution:
            "Zaprojektowaliśmy nową identyfikację wizualną, jednostronicową stronę z menu i mapą oraz prosty formularz rezerwacji integrujący się z e-mailem.",
        scope: ["Logo", "Identyfikacja wizualna", "Strona WWW", "Szablony social media"],
        result:
            "Spójny wizerunek, czytelna oferta i prosty kanał komunikacji z gośćmi – gotowy fundament do dalszego rozwoju marki.",
        concept: true,
    },
    {
        slug: "uslugi-budowlane",
        title: "Wizerunek firmy usługowej",
        category: "Branding + Strona WWW + Social media",
        problem:
            "Firma usługowa działająca od kilku lat lokalnie chciała profesjonalnie prezentować ofertę i docierać do klientów spoza miasta.",
        solution:
            "Stworzyliśmy nowoczesny branding, stronę z portfolio realizacji oraz harmonogram publikacji w social mediach.",
        scope: [
            "Strategia marki",
            "Projekt logo",
            "Strona z portfolio",
            "Konfiguracja profili",
            "Plan publikacji 30 dni",
        ],
        result:
            "Profesjonalna prezentacja oferty, jasne ścieżki kontaktu i przygotowanie do prowadzenia kampanii reklamowych.",
        concept: true,
    },
    {
        slug: "panel-saas",
        title: "Panel SaaS dla firmy szkoleniowej",
        category: "Aplikacja internetowa",
        problem:
            "Firma szkoleniowa zarządzała zapisami przez arkusze i e-maile, co generowało błędy i pochłaniało czas zespołu.",
        solution:
            "Zaprojektowaliśmy aplikację z panelem administratora, formularzem zapisów, automatycznymi potwierdzeniami i raportowaniem.",
        scope: [
            "Specyfikacja funkcji",
            "Projekt UX/UI",
            "Aplikacja webowa",
            "Integracja z e-mailem",
            "Dokumentacja",
        ],
        result:
            "Mniej ręcznej pracy, mniej błędów i przejrzysty proces zapisów dla uczestników szkoleń.",
        concept: true,
    },
];

export const process = [
    {
        n: 1,
        title: "Rozmowa i audyt",
        desc: "Poznajemy firmę, ofertę, odbiorców i cele projektu.",
    },
    {
        n: 2,
        title: "Strategia",
        desc: "Ustalamy komunikację, strukturę, kierunek wizualny i najważniejsze funkcje.",
    },
    {
        n: 3,
        title: "Projektowanie",
        desc: "Tworzymy stronę, identyfikację, treści i potrzebne materiały.",
    },
    {
        n: 4,
        title: "Prezentacja",
        desc: "Przedstawiamy przygotowany projekt i omawiamy najważniejsze decyzje.",
    },
    {
        n: 5,
        title: "Poprawki",
        desc: "Wprowadzamy uzgodnione zmiany zgodnie z zakresem wybranego pakietu.",
    },
    {
        n: 6,
        title: "Wdrożenie i publikacja",
        desc: "Konfigurujemy narzędzia, uruchamiamy stronę i publikujemy materiały.",
    },
    {
        n: 7,
        title: "Wsparcie i optymalizacja",
        desc: "Monitorujemy działanie i wskazujemy kolejne możliwości rozwoju.",
    },
];

export const faqs = [
    {
        q: "Ile kosztuje strona internetowa?",
        a: "Cena zależy od liczby podstron, funkcji, zakresu projektu i potrzebnych materiałów. Podstawowy pakiet zaczyna się od 2 190 zł. Przed rozpoczęciem współpracy otrzymasz jasny zakres i wycenę.",
    },
    {
        q: "Ile trwa realizacja?",
        a: "Prostsze projekty realizujemy zazwyczaj w ciągu 7–10 dni roboczych. Bardziej rozbudowane strony i systemy wymagają zwykle od 14 do 30 dni roboczych. Termin zależy także od szybkości dostarczenia materiałów i akceptacji projektu.",
    },
    {
        q: "Czy pomagacie w przygotowaniu tekstów?",
        a: "Tak. Możemy przygotować strukturę, nagłówki i treści sprzedażowe dopasowane do oferty oraz odbiorców firmy.",
    },
    {
        q: "Czy strona będzie działała na telefonie?",
        a: "Tak. Wszystkie strony projektujemy responsywnie, aby poprawnie działały na komputerach, tabletach i telefonach.",
    },
    {
        q: "Czy mogę samodzielnie edytować stronę?",
        a: "Tak. W zależności od wybranej technologii możemy przygotować prosty panel do edycji treści lub zapewnić stałą opiekę techniczną.",
    },
    {
        q: "Czy zapewniacie domenę i hosting?",
        a: "Pomagamy w wyborze, konfiguracji oraz podłączeniu domeny i hostingu. Ich koszt nie jest zawarty w podstawowej cenie pakietu, chyba że oferta indywidualna stanowi inaczej.",
    },
    {
        q: "Ile poprawek obejmuje projekt?",
        a: "Liczba rund poprawek zależy od wybranego pakietu. Dodatkowe zmiany mogą zostać wycenione osobno.",
    },
    {
        q: "Czy prowadzicie social media?",
        a: "Tak. Oferujemy przygotowanie strategii, grafik, treści, harmonogramów publikacji oraz stałe prowadzenie profili.",
    },
    {
        q: "Jak wykorzystujecie AI?",
        a: "Narzędzia AI pomagają nam przyspieszać analizę, przygotowywać warianty, tworzyć pierwsze wersje treści i automatyzować powtarzalne działania. Wszystkie materiały są sprawdzane i dopracowywane przed publikacją.",
    },
    {
        q: "Jak rozpocząć współpracę?",
        a: "Wypełnij formularz, wyślij e-mail lub zadzwoń. Po krótkiej rozmowie przygotujemy proponowany zakres, termin oraz wycenę.",
    },
];

export const blogSeed = [
    {
        slug: "jak-zbudowac-wizerunek-firmy-w-sieci",
        title: "Jak od zera stworzyć wizerunek firmy w sieci?",
        category: "Rozwój firmy",
    },
    {
        slug: "ile-kosztuje-profesjonalna-strona",
        title: "Ile kosztuje profesjonalna strona internetowa?",
        category: "Strony internetowe",
    },
    {
        slug: "7-bledow-strony",
        title: "7 błędów, przez które strona nie zdobywa klientów",
        category: "Strony internetowe",
    },
    {
        slug: "ai-w-marketingu",
        title: "Jak AI przyspiesza działania marketingowe?",
        category: "AI w biznesie",
    },
    {
        slug: "spojna-identyfikacja",
        title: "Jak stworzyć spójną identyfikację wizualną?",
        category: "Branding",
    },
    {
        slug: "lokalna-firma-strona",
        title: "Dlaczego lokalna firma potrzebuje strony internetowej?",
        category: "Rozwój firmy",
    },
    {
        slug: "social-media-malej-firmy",
        title: "Jak prowadzić social media małej firmy?",
        category: "Social media",
    },
];
